import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  linkedSignal,
  signal,
} from '@angular/core';
import {
  ButtonComponent,
  IconComponent,
  InputComponent,
  ResolvableModal,
  SoftSlotDirective,
} from '@softline/ui-core';
import { WorkflowParticipant, WorkflowRole } from '../../types/workflow';

@Component({
  selector: 'soft-workflow-participants-modal',
  imports: [ButtonComponent, IconComponent, InputComponent, SoftSlotDirective],
  templateUrl: './workflow-participants-modal.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkflowParticipantsModal extends ResolvableModal<
  WorkflowParticipant[] | null
> {
  readonly role = input<WorkflowRole | null>(null);
  readonly participants = input<WorkflowParticipant[]>([]);
  readonly title = input<'Benutzer' | 'Gruppen'>('Benutzer');

  readonly search = signal<string | null>(null);

  readonly selectedIds = linkedSignal<string[]>(
    () => this.role()?.participants.map((p) => p.id) ?? []
  );

  readonly filteredParticipants = computed(() => {
    const term = this.search()?.toLowerCase().trim();
    return term
      ? this.participants().filter((p) => p.name.toLowerCase().includes(term))
      : this.participants();
  });

  isSelected(id: string): boolean {
    return this.selectedIds().includes(id);
  }

  toggleParticipant(id: string): void {
    const current = this.selectedIds();
    this.selectedIds.set(
      current.includes(id) ? current.filter((x) => x !== id) : [...current, id]
    );
  }

  resolveModal(): void {
    const ids = this.selectedIds();
    this.resolve(this.participants().filter((p) => ids.includes(p.id)));
  }
}
